module.exports = function (Utils) {
    'use strict';
    var pointOptions = [
        'peaks',
        'id',
        'time',
        'labelText',
        'color',
        'editable'
    ];
    function validatePoint(options, context) {
        if (!Utils.isValidTime(options.time)) {
            throw new TypeError('peaks.points.' + context + ': time should be a numeric value');
        }
        if (options.time < 0) {
            throw new RangeError('peaks.points.' + context + ': time should not be negative');
        }
        if (Utils.isNullOrUndefined(options.labelText)) {
            options.labelText = '';
        } else if (!Utils.isString(options.labelText)) {
            throw new TypeError('peaks.points.' + context + ': labelText must be a string');
        }
        if (!Utils.isBoolean(options.editable)) {
            throw new TypeError('peaks.points.' + context + ': editable must be true or false');
        }
    }
    function Point(options) {
        validatePoint(options, 'add()');
        this._peaks = options.peaks;
        this._id = options.id;
        this._time = options.time;
        this._labelText = options.labelText;
        this._color = options.color;
        this._editable = options.editable;
        this._setUserData(options);
    }
    Point.prototype._setUserData = function (options) {
        for (var key in options) {
            if (Utils.objectHasProperty(options, key) && pointOptions.indexOf(key) === -1) {
                this[key] = options[key];
            }
        }
    };
    Object.defineProperties(Point.prototype, {
        id: {
            enumerable: true,
            get: function () {
                return this._id;
            }
        },
        time: {
            enumerable: true,
            get: function () {
                return this._time;
            }
        },
        labelText: {
            get: function () {
                return this._labelText;
            }
        },
        color: {
            enumerable: true,
            get: function () {
                return this._color;
            }
        },
        editable: {
            enumerable: true,
            get: function () {
                return this._editable;
            }
        }
    });
    Point.prototype.update = function (options) {
        var opts = {
            time: this.time,
            labelText: this.labelText,
            color: this.color,
            editable: this.editable
        };
        Utils.extend(opts, options);
        validatePoint(opts, 'update()');
        this._time = opts.time;
        this._labelText = opts.labelText;
        this._color = opts.color;
        this._editable = opts.editable;
        this._setUserData(options);
        this._peaks.emit('points.update', this);
    };
    Point.prototype.isVisible = function (startTime, endTime) {
        return this.time >= startTime && this.time < endTime;
    };
    Point.prototype._setTime = function (time) {
        this._time = time;
    };
    return Point;
}(require('./utils'));